import { APIUrls } from "../../Constants/ApiUrls";
import { AjaxService, IAPIRequest, IAPIResponse } from "../AjaxService";

const SessionController = {
  Login: async (
    identifier: string,
    password: string,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.LOGIN_URL;
    request.method = "POST";
    request.payload = {
      identifier,
      password,
    };
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
};

export default SessionController;
